export const FETCH_GYMNASTICS_LISTING = "FETCH_GYMNASTICS_LISTING";
export const FETCH_GYMNASTICS_LISTING_BEGIN = "FETCH_GYMNASTICS_LISTING_BEGIN";
export const FETCH_GYMNASTICS_LISTING_SUCCESS = "FETCH_GYMNASTICS_LISTING_SUCCESS";
export const FETCH_GYMNASTICS_LISTING_ERROR = "FETCH_GYMNASTICS_LISTING_ERROR";
